import { render } from "./NewVation5Pictures.vue?vue&type=template&id=f8e8c960&scoped=true&ts=true"
import script from "./NewVation5Pictures.vue?vue&type=script&lang=ts"
export * from "./NewVation5Pictures.vue?vue&type=script&lang=ts"

import "./NewVation5Pictures.vue?vue&type=style&index=0&id=f8e8c960&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e8c960"]])

export default __exports__